<!-- Main Layout -->
<div class="text-gray-800 dark:text-white relative min-h-screen">
  <!-- Sidebar  -->
  <aside
    id="separator-sidebar"
    class="fixed top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full sm:translate-x-0"
    [class.translate-x-0]="layoutService.isSidebarOpen()"
    aria-label="Sidebar"
  >
    <div
      class="h-full px-3 py-4 overflow-y-auto bg-white dark:bg-gray-800 shadow-sm border-r border-gray-200 dark:border-gray-700"
    >
      @if (!production) {
        <div
          class="flex items-center p-2 mb-2 bg-yellow-200 text-orange-500 dark:bg-yellow-900 dark:text-yellow-500 rounded-lg justify-center"
        >
          <div class="w-6 h-6">🚧</div>
          <span class="ms-1 mr-2 font-bold">STAGING</span>
          <div class="w-6 h-6">🚧</div>
        </div>
      }

      @for (navSection of navSections; track navSection) {
        <ul
          [class]="
            !$first
              ? 'space-y-2 font-medium pt-4 mt-4 border-t border-gray-200 dark:border-gray-700'
              : 'space-y-2 font-medium'
          "
        >
          @for (navItem of navSection.items; track navItem) {
            <li>
              <a
                routerLink="{{ navItem.route }}"
                class="flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group transition"
                (click)="navItem.action ? navItem.action() : layoutService.toggleSidebar()"
              >
                <app-nav-icon
                  [name]="navItem.icon"
                  [strokeWidth]="0"
                  [fill]="navItem.fill ? navItem.fill : 'currentColor'"
                ></app-nav-icon>
                <span class="ms-3">{{ navItem.label }}</span>
              </a>
            </li>
          }
        </ul>
      }
    </div>
  </aside>

  <!-- Sidebar Backdrop -->
  @if (layoutService.isSidebarOpen()) {
    <div
      class="fixed inset-0 bg-white/10 backdrop-blur-sm block sm:hidden z-30"
      (click)="layoutService.toggleSidebar()"
    ></div>
  }

  <!-- Main Content Area -->
  <main class="flex-1 overflow-y-auto md:pt-0 md:pb-0 sm:ml-64">
    <router-outlet class="bg-gray-100 dark:bg-gray-800"></router-outlet>
  </main>
</div>
